// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteLink__link-fbdf34 {
  cursor: pointer;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--brand-primary-40);
  text-align: left;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  width: 100%;
}

.InviteLink__link-fbdf34:hover,
.InviteLink__link-fbdf34:focus {
  color: var(--brand-primary-50);
}

.InviteLink__link-fbdf34:active {
  color: var(--brand-primary-60);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/components/InviteLink/styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;;EAEE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF","sourcesContent":[".link {\n  cursor: pointer;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--brand-primary-40);\n  text-align: left;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.link:hover,\n.link:focus {\n  color: var(--brand-primary-50);\n}\n\n.link:active {\n  color: var(--brand-primary-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `InviteLink__link-fbdf34`
};
module.exports = ___CSS_LOADER_EXPORT___;
